module.exports = __webpack_public_path__ + "img/nutricion.d31a0e1c.svg";